import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SaleAction } from '../../store/actions';

class AngikarNama extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  render() {
    return (
      <div
        style={{
          fontSize: '30px',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          wordSpacing: '5px',
        }}
      >
        <div className="row">
          <div className="col">
            <div style={{ height: '11rem' }} />
            <p className="h1 mb-5 text-center">
              <u>অঙ্গীকার নামা</u>
            </p>
            <p className="mb-5 text-justify">
              এই মর্মে অঙ্গীকার করা যাচ্ছে যে, নিম্ন বর্ণিত মটরসাইকেলটি আমাদের
              শোরুম হইতে গত{' '}
              <u style={{ textDecorationStyle: 'dotted' }}>
                {this.props.sale?.sold_at}
              </u>{' '}
              ইং তারিখে জনাব:{' '}
              <u style={{ textDecorationStyle: 'dotted' }}>
                {this.props.sale?.customer?.name}
              </u>{' '}
              পিতা:{' '}
              <u style={{ textDecorationStyle: 'dotted' }}>
                {this.props.sale?.customer?.father_name}
              </u>{' '}
              স্থায়ী ঠিকানা:{' '}
              <u style={{ textDecorationStyle: 'dotted' }}>
                {this.props.sale?.customer?.address}
              </u>{' '}
              এর নিকট বিক্রয় করা হয়েছে। বর্তমান ঠিকানা{' '}
              <u style={{ textDecorationStyle: 'dotted' }}>
                {this.props.sale?.customer?.address}
              </u>{' '}
              রেজিস্ট্রেশন সংক্রান্ত বিষয়ে যে সকল কাগজপত্র দাখিল করা হয়েছে তা
              ক্রেতা বরাবরে আমরা প্রদান করেছি। দাখিলকৃত কাগজ পত্রে ভবিষ্যতে কোন
              জটিলতা সৃষ্টি হলে আমাদের শোরুম সম্পূর্ণ দায়ভার বহন করবে এর জন্য
              বিআরটিএ, কোন প্রকার দায়ভার বহন করবে না। মোটরসাইকেলটির তথ্যাদি
              নিম্নে প্রদান করা হলো।
            </p>
            <p className="mb-5">
              <u>তথ্যাদি:</u>
              <br />
              ১। চেসিস নং: {this.props.sale?.purchase?.chassis_number}
              <br />
              ২। ইঞ্জিন নং: {this.props.sale?.purchase?.engine_number}
              <br />
              ৩। প্রস্তুত কাল:{' '}
              {this.props.sale?.purchase?.vehicle?.manufacture_year}
              <br />
              ৪। প্রস্তুতকারক দেশ: INDIA
              <br />
              ৫। রং: {this.props.sale?.purchase?.color?.name}
              <br />
              ৬। সিসি: {this.props.sale?.purchase?.vehicle?.cylinder_cc}
            </p>
            <p className="text-right">নিবেদক</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AngikarNama);
